/**
 * Returns a random index from an array that does not equate to the current value indicated
 * @param {number} currentIndex
 * @param {Array} arr
 * @returns {number}
 */
function nextIndex(currentIndex, arr) {
  let newIndex;
  do {
    newIndex = Math.round(Math.random() * (arr.length - 1));
  } while (newIndex === currentIndex);

  return newIndex;
}

export { nextIndex as default };
